import BossModel from "@/models/BossModel";
import PersonalDetail from "./PersonalDetail";

export default class OpenRequest extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-offer/open-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteOfferOpenRequests';

    static fields() {
        return {
            id: this.attr(null),
            website_offer_personal_detail_id: this.attr(null),
            start_date: this.attr(null),
            start_date_flexible: this.attr(null),
            trip_duration: this.attr(null),
            country_id: this.attr(null),
            subjects: this.attr(null),
            need_tickets: this.attr(null),
            trip_notes: this.attr(null),
            personal_detail: this.belongsTo(PersonalDetail, 'website_offer_personal_detail_id'),
        }
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PersonalDetail() {
        return this.getRelated('personal_detail');
    }
}
